import { render } from "./Files.vue?vue&type=template&id=05920c00"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"

import "./Files.vue?vue&type=style&index=0&id=05920c00&lang=scss"
import "./Files.vue?vue&type=style&index=1&id=05920c00&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__